import { all, call, fork, put, takeEvery } from "redux-saga/effects";
// import {} from "jwt-decode"
import database from "../database/database";
import { signInUserWithEmailPasswordRequest } from "../api/auth";
import {
  SIGNIN_FACEBOOK_USER,
  SIGNIN_GOOGLE_USER,
  SIGNIN_USER,
  SIGNOUT_USER
} from "../constants/ActionTypes";
import {
  showAuthMessage,
  userSignInSuccess,
  userSignOutSuccess,
} from "../actions/Auth";

import { resetDashboard } from "../actions/DashboardAction";
import { resetPlayers } from "../actions/PlayerAction";
import { resetCoaches } from "../actions/CoachAction";
import { resetPlayerReport } from "../actions/PlayerReportAction";
import { resetSession } from "../actions/SessionAction";
import { resetSwing } from "../actions/SwingAction";
import { resetMedia } from "../actions/MediaAction";

// const signInUserWithEmailPasswordRequest = async (email, password) =>
//   await database.User.logIn(email, password)
//     .then(authUser => {
//       const convertTojson = authUser.toJSON()
//       return { user: convertTojson }
//     })
//     .catch(error => error)

// const signOutRequest = async () =>
//   await database.User.logOut()
//     .then(authUser => undefined)
//     .catch(error => error);


function* signInUserWithEmailPassword({ payload }) {
  const { email, password } = payload;
  try {
    if (email.length > 0 && password.length > 0) {
      if ((email.indexOf("@") >= 0) && (email.indexOf(".") >= 0)) {
        const signInUser = yield call(signInUserWithEmailPasswordRequest, email, password);
        if (signInUser.sessionToken) {
          localStorage.setItem('sb', signInUser.sessionToken);
          try {
            const jwtDecode = require('jwt-decode');
            const decoded = jwtDecode(signInUser.sessionToken);
            // console.log(decoded.sub);
            var authUser = JSON.parse(decoded.sub);
            authUser['sessionToken'] = signInUser.sessionToken;
            // console.log(authUser);
            yield put(userSignInSuccess(authUser));
          } catch (error) {
            yield put(showAuthMessage("Something went wrong! Please try again."));
          }
        } else {
          yield put(showAuthMessage("Invalid username/password"));
        }


        // if (signInUser.message) {
        //   yield put(showAuthMessage(signInUser.message));
        // } else {
        //   localStorage.setItem('type', 'm');
        //   localStorage.setItem('user_id', signInUser.user.objectId);
        //   var todaysDate = new Date();
        //   var sessionArray = [];
        //   const playerInfo = yield call(fetchPlayerInfo, signInUser.user.objectId);
        //   if (playerInfo) {
        //     localStorage.setItem('players', playerInfo);
        //     // const recordInfo = yield call(readyRecord, signInUser.user.objectId);
        //     // if (recordInfo) {
        //     //   localStorage.setItem('records', "[" + recordInfo + "]");
        //     // } else {
        //     //   console.log(recordInfo)
        //     // }
        //     // const sessionInfo = yield call(fetchSessions, signInUser.user.objectId, todaysDate, sessionArray);
        //     // if (sessionInfo) {
        //     //   localStorage.setItem('sessions', sessionInfo);
        //     // } else {
        //     //   console.log(sessionInfo)
        //     // }
        //     yield put(userSignInSuccess(signInUser.user.objectId));
        //   } else {
        //     try {
        //       const signOutUser = yield call(signOutRequest);
        //       if (signOutUser === undefined) {
        //         localStorage.removeItem('user_id');
        //         localStorage.removeItem('players');
        //         localStorage.removeItem('records');
        //         localStorage.removeItem('sessions');
        //         localStorage.removeItem('swings');
        //         localStorage.removeItem('sselect');
        //         localStorage.removeItem('type');
        //         yield put(showAuthMessage('Something went wrong! Please try again'));
        //         return
        //         // yield put(userSignOutSuccess(signOutUser));
        //       } else {
        //         yield put(showAuthMessage(signOutUser.message));
        //       }
        //     } catch (error) {
        //       yield put(showAuthMessage(error));
        //     }
        //     // console.log(playerInfo)
        //   }
        // }


      } else {
        yield put(showAuthMessage("Invalid Email Id Entered!"));
      }
    } else {
      yield put(showAuthMessage("Email/Password is required"));
    }
  } catch (error) {
    yield put(showAuthMessage(error));
  }
}

const signOutRequest = async () => {

}

function* signOut() {
  try {
    localStorage.removeItem('sb');
    yield put(resetDashboard());
    yield put(resetPlayers());
    yield put(resetCoaches());
    yield put(resetPlayerReport());
    yield put(resetSession());
    yield put(resetSwing());
    yield put(resetMedia());
    yield put(userSignOutSuccess(signOutUser));
  } catch (error) {
    console.log(error)
    yield put(showAuthMessage(error));
  }
}

const fetchPlayerInfo = async (userId) => {
  const PlayerInfo = database.Object.extend("PlayerInfo");
  const playerQuery = new database.Query(PlayerInfo);
  playerQuery.equalTo("userId", userId);
  return await playerQuery.find()
    .then(playerInfoResults => {
      if (playerInfoResults.length > 0) {
        return JSON.stringify(playerInfoResults[0])
      } else {
        return undefined
      }
    })
    .catch(error => {
      console.log("error : " + error.message);
    })
}


const readyRecord = async (userId) => {
  const recordTag = ['MAX_SPEED_AT_IMPACT', 'MAX_SPEED', 'MAX_POWER']
  return await Promise.all(recordTag.map((value, index) => fetchRecordInfo(userId, value)))
}

const fetchRecordInfo = async (userId, tag) => {
  const RecordInfo = database.Object.extend("StatsInfo");
  const recordQuery = new database.Query(RecordInfo);
  recordQuery.equalTo("userId", userId);
  recordQuery.equalTo('tag', tag);
  recordQuery.descending('createdAt');
  recordQuery.limit(1);
  return await recordQuery.find()
    .then(recordInfoResults => {
      if (recordInfoResults.length > 0) {
        return (JSON.stringify(recordInfoResults[0]))
      } else {
        return 0
      }
    })
    .catch(error => {
      console.log("error : " + error.message);
    })
}

const fetchSessions = async (userId, fromDate, sessionArray) => {
  const SessionInfo = database.Object.extend("SessionInfo");
  const sessionQuery = new database.Query(SessionInfo);
  sessionQuery.equalTo("userId", userId);
  sessionQuery.notEqualTo("isDeleted", true);
  sessionQuery.equalTo("sessionStatus", "completed");
  sessionQuery.descending("completionDate");
  sessionQuery.lessThan("completionDate", fromDate);
  sessionQuery.limit(20);
  return await sessionQuery.find()
    .then(sessionInfoResults => {
      if (sessionInfoResults.length > 0) {
        var newSessionArray = sessionArray.concat(sessionInfoResults);
        if (sessionInfoResults.length === 20) {
          var date = new Date(sessionInfoResults[sessionInfoResults.length - 1].get('completionDate'));
          return fetchSessions(userId, date, newSessionArray)
        } else {
          return JSON.stringify(newSessionArray)
        }
      } else {
        return JSON.stringify(sessionArray)
      }
    })
    .catch(error => {
      console.log("error : " + error.message);
    })
}

const userExistRequest = async (id) => {
  try {
    const databaseUrl = database.serverURL;

    const reqObject = {
      'username': id
    }
    const userExistResponse = await fetch(
      databaseUrl + "functions/checkUserExists",
      {
        method: "POST",
        headers: {
          'X-Parse-Application-Id': 'AA4071F5A30CA6525E2AED19ABA3F77AF72F90592412DBB707D55BCE7A86F3FDDBAB591E34D6014E6B8E1CC2F2ACD57E9D3731CD97F509EC65CDF7AC0A779897',
          'X-Parse-REST-API-Key': '3nI5MbGYmXrX94RDIdhBQCaAMMIUrGgXepjdgaHI'
        },
        body: JSON.stringify(reqObject)
      }
    )
    return await userExistResponse.json();
  } catch (errors) {
    return undefined
  }
}

const userMeCall = async (sessionToken) => {
  return await database.User.become(sessionToken)
    .then(becomeResponse => {
      return becomeResponse
    })
    .catch(error => {
      return error
    })
}

//Google Login
function* signInUserWithGoogle({ payload }) {
  try {
    if (!payload.googleId) {
      yield put(showAuthMessage("Something went wrong! Please try again."));
      return
    }
    const userExist = yield call(userExistRequest, payload.profileObj.email);
    if (userExist) {
      console.log("userExist : " + userExist.result.result)
      if (userExist.result.result === 'yes') {
        const googleSignInApiResponse = yield call(googleSignInApiCall, payload);
        if (googleSignInApiResponse.error) {
          console.log("googleSignInApiResponse : " + googleSignInApiResponse.error)
          yield put(showAuthMessage('Something went wrong! Please try again'));
        } else {
          const userMeResponse = yield call(userMeCall, googleSignInApiResponse.result);
          if (userMeResponse.id) {
            localStorage.setItem('type', 'g');
            localStorage.setItem('user_id', userMeResponse.id);
            var todaysDate = new Date();
            var sessionArray = [];
            const playerInfo = yield call(fetchPlayerInfo, userMeResponse.id);
            if (playerInfo) {
              localStorage.setItem('players', playerInfo);
              const recordInfo = yield call(readyRecord, userMeResponse.id);
              if (recordInfo) {
                localStorage.setItem('records', "[" + recordInfo + "]");
              } else {
                console.log(recordInfo)
              }
              const sessionInfo = yield call(fetchSessions, userMeResponse.id, todaysDate, sessionArray);
              if (sessionInfo) {
                localStorage.setItem('sessions', sessionInfo);
              } else {
                console.log(sessionInfo)
              }
              yield put(userSignInSuccess(userMeResponse.id));
            } else {
              try {
                const signOutUser = yield call(signOutRequest);
                if (signOutUser === undefined) {
                  localStorage.removeItem('user_id');
                  localStorage.removeItem('players');
                  localStorage.removeItem('records');
                  localStorage.removeItem('sessions');
                  localStorage.removeItem('swings');
                  localStorage.removeItem('sselect');
                  localStorage.removeItem('type');
                  yield put(showAuthMessage('Something went wrong! Please try again'));
                  return
                } else {
                  yield put(showAuthMessage("Something went wrong! Please try again"));
                  return
                }
              } catch (error) {
                yield put(showAuthMessage("Something went wrong! Please try again"));
                return
              }
            }
          } else {
            yield put(showAuthMessage('Something went wrong! Please try again'));
            console.log("userMeResponse : " + userMeResponse.error)
            return
          }
        }
      } else {
        yield put(showAuthMessage("User not found!"));
      }
    } else {
      yield put(showAuthMessage("Something went wrong! Please try again"));
    }
  } catch (error) {
    yield put(showAuthMessage("Something went wrong! Please try again"));
  }
}
const googleSignInApiCall = async (payload) => {
  const authData = {
    'id': payload.googleId,//payload.id,
    'idToken': payload.tokenId,
    'GClientId': '313348750424-slov7kepkavnakpq84o4ut1qbun1cs2b.apps.googleusercontent.com',
    'email': payload.profileObj.email,
    'action': 'login'
  }
  try {
    const databaseUrl = database.serverURL;
    const googleSignInApiResponse = await fetch(
      databaseUrl + "functions/googleSignInApi",
      {
        method: "POST",
        headers: {
          'X-Parse-Application-Id': 'AA4071F5A30CA6525E2AED19ABA3F77AF72F90592412DBB707D55BCE7A86F3FDDBAB591E34D6014E6B8E1CC2F2ACD57E9D3731CD97F509EC65CDF7AC0A779897',
          'X-Parse-REST-API-Key': '3nI5MbGYmXrX94RDIdhBQCaAMMIUrGgXepjdgaHI'
        },
        body: JSON.stringify(authData)
      }
    )
    return await googleSignInApiResponse.json();
  } catch (errors) {
    return undefined
  }
}

//Facebook Login
function* signInUserWithFacebook({ payload }) {
  try {
    if (!payload.id) {
      yield put(showAuthMessage("Something went wrong! Please try again."));
      return
    }
    const userExist = yield call(userExistRequest, payload.id);
    if (userExist) {
      console.log("userExist : " + userExist.result.result)
      if (userExist.result.result === 'yes') {
        const facebookSignInApiResponse = yield call(facebookSignInApiCall, payload);
        if (facebookSignInApiResponse.error) {
          console.log("facebookSignInApiResponse : " + facebookSignInApiResponse.error)
          yield put(showAuthMessage('Something went wrong! Please try again'));
        } else {
          const userMeResponse = yield call(userMeCall, facebookSignInApiResponse.result);
          if (userMeResponse.id) {
            localStorage.setItem('type', 'f');
            localStorage.setItem('user_id', userMeResponse.id);
            var todaysDate = new Date();
            var sessionArray = [];
            const playerInfo = yield call(fetchPlayerInfo, userMeResponse.id);
            if (playerInfo) {
              localStorage.setItem('players', playerInfo);
              const recordInfo = yield call(readyRecord, userMeResponse.id);
              if (recordInfo) {
                localStorage.setItem('records', "[" + recordInfo + "]");
              } else {
                console.log(recordInfo)
              }
              const sessionInfo = yield call(fetchSessions, userMeResponse.id, todaysDate, sessionArray);
              if (sessionInfo) {
                localStorage.setItem('sessions', sessionInfo);
              } else {
                console.log(sessionInfo)
              }
              yield put(userSignInSuccess(userMeResponse.id));
            } else {
              try {
                const signOutUser = yield call(signOutRequest);
                if (signOutUser === undefined) {
                  localStorage.removeItem('user_id');
                  localStorage.removeItem('players');
                  localStorage.removeItem('records');
                  localStorage.removeItem('sessions');
                  localStorage.removeItem('swings');
                  localStorage.removeItem('sselect');
                  localStorage.removeItem('type');
                  yield put(showAuthMessage('Something went wrong! Please try again'));
                  return
                } else {
                  yield put(showAuthMessage("Something went wrong! Please try again."));
                  return
                }
              } catch (error) {
                yield put(showAuthMessage("Something went wrong! Please try again."));
                return
              }
            }
          } else {
            console.log("userMeResponse : " + userMeResponse.error)
          }
        }
      } else {
        yield put(showAuthMessage("User not found!"));
      }
    } else {
      yield put(showAuthMessage("Something went wrong! Please try again."));
    }
  } catch (error) {
    yield put(showAuthMessage("Something went wrong! Please try again."));
  }
}
const facebookSignInApiCall = async (payload) => {
  const authData = {
    'id': payload.userID,//payload.id,
    'access_token': payload.accessToken,
    'expiration_date': new Date(payload.data_access_expiration_time).toString(),
    'app_id': '698483573982043',//payload.id,
    'action': 'login'
  }
  try {
    const databaseUrl = database.serverURL;
    const facebookSignInApiResponse = await fetch(
      databaseUrl + "functions/facebookSignInApi",
      {
        method: "POST",
        headers: {
          'X-Parse-Application-Id': 'AA4071F5A30CA6525E2AED19ABA3F77AF72F90592412DBB707D55BCE7A86F3FDDBAB591E34D6014E6B8E1CC2F2ACD57E9D3731CD97F509EC65CDF7AC0A779897',
          'X-Parse-REST-API-Key': '3nI5MbGYmXrX94RDIdhBQCaAMMIUrGgXepjdgaHI'
        },
        body: JSON.stringify(authData)
      }
    )
    return await facebookSignInApiResponse.json();
  } catch (errors) {
    return undefined
  }
}

export function* signInUser() {
  yield takeEvery(SIGNIN_USER, signInUserWithEmailPassword);
}

export function* signOutUser() {
  yield takeEvery(SIGNOUT_USER, signOut);
}

export function* signInWithFacebook() {
  yield takeEvery(SIGNIN_FACEBOOK_USER, signInUserWithFacebook);
}

export function* signInWithGoogle() {
  yield takeEvery(SIGNIN_GOOGLE_USER, signInUserWithGoogle);
}

export default function* rootSaga() {
  yield all([fork(signInUser),
  fork(signInWithGoogle),
  fork(signInWithFacebook),
  fork(signOutUser)]);
}